export interface ICollectorConfig {
  [0]: string;
  [1]: ((payload: string) => void) | string | number | object;
}

export interface ICollector extends Array<ICollectorConfig> {
  [index: number]: ICollectorConfig;
  push: (conf: ICollectorConfig) => number;
}

export interface ICollectorCustomIdentifiers {
  sid: string;
  tid: string;
}

export interface ILogger {
  error(msg: string): void;
  info?(msg: string): void;
}

export interface IClientProfilerOptions {
  filename: string;
  generateTransactionId(): string;
  host: string;
  loader(url: string): Promise<void>;
  logger: ILogger;
  siteKey: string;
}

export interface IClientProfile {
  payload: string;
  transactionId: string;
}

export enum ECollectorCommand {
  CUSTOM_IDENTIFIERS = 'ci',
  GENERATE_PAYLOAD = 'cfp',
  RUN = 'run',
}
